import React from 'react'
import { useSelector } from 'react-redux'
import { State } from '../types/state'

const LoadingSpinnerProvider = (): JSX.Element => {
  const { isSpinnerVisible } = useSelector((state: State) => state.refresh)

  return isSpinnerVisible
    ? (
      <div className='preloader'>
        <div className='sk-cube-grid'>
          <span className='sk-cube' />
          <span className='sk-cube' />
          <span className='sk-cube' />
          <span className='sk-cube' />
          <span className='sk-cube' />
          <span className='sk-cube' />
          <span className='sk-cube' />
          <span className='sk-cube' />
          <span className='sk-cube' />
        </div>
      </div>
      )
    : (
      <></>
      )
}

export default LoadingSpinnerProvider
